import React from 'react';

const AbandonPackageButton = ({ onFinish }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: '20px' }}>
      <button
        className="btn btn-danger"
        onClick={onFinish}
      >
        Abandon Package
      </button>
    </div>
  );
}

export default AbandonPackageButton;
